<template>
  <v-container fluid>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-card class="elevation-12">
          <v-toolbar
              color="primary"
              flat
          >
            <v-spacer/>
            <v-toolbar-title >KAYIT OL</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-row dense>

            <v-col :cols="$vuetify.breakpoint.smAndUp? 6: 12">
              <ValidationProvider v-slot="{ errors }" rules="required|alpha_spaces">
                <v-text-field
                    v-model="firstName"
                    :error-messages="errors"
                    label="Ad"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                ></v-text-field>
              </ValidationProvider>

            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndUp? 6: 12">
              <ValidationProvider v-slot="{ errors }" rules="required|alpha_spaces">
                <v-text-field
                    v-model="secondName"
                    :error-messages="errors"
                    label="Soyad"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                ></v-text-field>
              </ValidationProvider>

            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndUp? 6: 12">
              <ValidationProvider v-slot="{ errors }" rules="required|alpha_dash">
                <v-text-field
                    v-model="authDetails.username"
                    :error-messages="errors"
                    label="Kullanıcı adı"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                ></v-text-field>
              </ValidationProvider>

            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndUp? 6: 12">
              <ValidationProvider v-slot="{ errors }" rules="required|email">
                <v-text-field
                    v-model="authDetails.email"
                    :error-messages="errors"
                    label="Email"
                    name="email"
                    prepend-icon="mdi-email"
                    type="text"
                ></v-text-field>
              </ValidationProvider>

            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndUp? 6: 12" >
              <ValidationProvider v-slot="{ errors }" rules="required|alpha_dash|confirmed:confirmation">
                <v-text-field
                    v-model="authDetails.password"
                    :error-messages="errors"
                    id="password"
                    label="Şifre"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                ></v-text-field>
              </ValidationProvider>

            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndUp? 6: 12" >
              <ValidationProvider v-slot="{ errors }" vid="confirmation">
                <v-text-field
                    v-model="authDetails.password2"
                    :error-messages="errors"
                    id="password2"
                    label="Şifreyi yeniden girin"
                    name="password2"
                    prepend-icon="mdi-lock"
                    type="password"
                ></v-text-field>
              </ValidationProvider>

            </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="registerUser">Kayıt Ol</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <my-snackbar ref="snackbar"/>
    </v-row>
  </v-container>

</template>


<script>
import { mapActions } from 'vuex'
import { extend, ValidationProvider} from "vee-validate";
import {email, required, confirmed, alpha_dash, alpha_spaces} from "vee-validate/dist/rules";
import MySnackbar from "@/components/mySnackbar";



extend('required', {
  ...required,
  message: 'Bu alan boş bırakılamaz',
})

extend('email', {
  ...email,
  message: 'Email geçerli değil',
})

extend('confirmed', {
  ...confirmed,
  message: 'Şifreler eşleşmiyor',
})

extend('alpha_dash', {
  ...alpha_dash,
  message: 'Sadece harf, rakam, ve tire kullanılabilir',
})

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Sadece boşluk ve harf kullanılabilir',
})

export default {
  name: 'Login',
  components: {
    MySnackbar,
    ValidationProvider
  },

  data () {
    return {
      dialog:true,
      firstName: '',
      secondName: '',
      authDetails: {
        username: '',
        email: '',
        password: '',
        password2: '',
      },
      error: '',
    }
  },
  methods: {
    ...mapActions(['register']),
    registerUser: function () {
      this.error = ''
      this.register({name: `${this.firstName} ${this.secondName}`, ...this.authDetails})
          .catch(err => {this.error = err; this.raiseSnackbar(err.message)})
          .then(() => this.error || this.$router.push('/dashboard'))
    }
  }
}
</script>
